import {
  CalendarEventAvailability,
  ExternalConnectionsProviders,
} from '@griply/types';

const GOOGLE_OPTIONS = [
  CalendarEventAvailability.Busy,
  CalendarEventAvailability.Free,
];

const OUTLOOK_OPTIONS = [
  CalendarEventAvailability.Busy,
  CalendarEventAvailability.Free,
  CalendarEventAvailability.Tentative,
  CalendarEventAvailability.OutOfOffice,
  CalendarEventAvailability.WorkingElsewhere,
];

export const CALENDAR_EVENT_AVAILABILITY_LABEL_KEYS: Record<
  CalendarEventAvailability,
  string
> = {
  [CalendarEventAvailability.Busy]: 'forms.event.fields.busy.options.busy',
  [CalendarEventAvailability.Free]: 'forms.event.fields.busy.options.free',
  [CalendarEventAvailability.Tentative]:
    'forms.event.fields.busy.options.tentative',
  [CalendarEventAvailability.OutOfOffice]:
    'forms.event.fields.busy.options.out-of-office',
  [CalendarEventAvailability.WorkingElsewhere]:
    'forms.event.fields.busy.options.working-elsewhere',
};

// Google can only store busy/free, so offering the rest would offer writes that silently do nothing.
export const getCalendarEventAvailabilityOptions = (
  provider?: ExternalConnectionsProviders | null,
): CalendarEventAvailability[] =>
  provider === ExternalConnectionsProviders.Outlook
    ? OUTLOOK_OPTIONS
    : GOOGLE_OPTIONS;
